export const orttoTransactionalCommunicationKeys = {
  root: () => ['orttoTransactionalCommunication'] as const,
  customer: (customerID: string | undefined) =>
    [...orttoTransactionalCommunicationKeys.root(), customerID] as const,
};

export function parseOrttoTransactionalCommunicationKey(
  queryKey: ReturnType<typeof orttoTransactionalCommunicationKeys.customer>
) {
  const [, customerID] = queryKey;
  return { customerID };
}
